import React from "react";
import styles from "./Socials.module.scss";
import { CustomLink } from "@/components/Global/CustomLink";

import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { OptionsSocialMediaType } from "@/types/OptionType";
import { Post } from "@/wp/types/client";
import { SVGFromURL } from "@/components/SVGFromURL/SVGFromURL";

interface SocialsProps {
  socials: Post<"team">["acf"]["header_team"]["socials"];
  socialMedia: OptionsSocialMediaType;
}

export const Socials = ({ socials, socialMedia }: SocialsProps) => {
  const { getLabel } = useGlobalContext();
  const platforms = socialMedia?.platforms || [];

  return (
    <div className={styles["team-socials"]}>
      {socials &&
        socials.map((social, index) => {
          const socialType = social.social_media || "";
          const arialLabel = getLabel("aria_label_socials")?.replace(
            `"$title_social_network"`,
            socialType,
          );

          const platform = platforms.find(
            (platform) => platform.name === socialType,
          );

          return (
            <CustomLink
              id={`social-${index}`}
              className={styles.social}
              target="_blank"
              rel="noopener"
              aria-label={arialLabel}
              key={index}
              href={social.link ? social.link.url : ""}
            >
              {
                <SVGFromURL
                  width={24}
                  height={24}
                  src={platform?.icon?.url || ""}
                />
              }
            </CustomLink>
          );
        })}
    </div>
  );
};
